import Vue from 'vue';
import Toast, {POSITION, TYPE} from 'vue-toastification';
import './assets/styles/toasts.sass'

/**
 * Returns a custom render function which creates an instance of a FontAwesomeIcon with the given `iconProp` value.
 * @param {string[]} iconProp The array passed into the `icon` prop of a FontAwesomeIcon component
 * @returns {object}
 */
const customFaIcon = function (iconProp) {
    return {
        render: (createElement) => createElement(
            'font-awesome-icon',{
            props: {
              icon: iconProp,
            },
        }),
    };
};

Vue.use(Toast, {
  position: POSITION.TOP_CENTER,
  toastDefaults: {
    [TYPE.DEFAULT]: { 
        icon: customFaIcon(['fa', 'info-circle']),
    },
    [TYPE.INFO]: { 
      icon: customFaIcon(['fas', 'info-circle']),
    },
    [TYPE.SUCCESS]: {
        icon: customFaIcon(['far', 'check-circle']),
    },
    [TYPE.WARNING]: {
        icon: customFaIcon(['fa', 'exclamation-circle']),
    },
    [TYPE.ERROR]: {
        icon: customFaIcon(['fas', 'exclamation-triangle']),
    },
  }
});
